import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'
import { Layout } from '../components'
// Mui
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
// firebase
import { db } from '../firebase'

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}

const CustomerManager = ()=>{

    const dispatch = useDispatch()

    const [customers, setCustomers] = useState('')

    useEffect(()=>{
        db.collection('users').orderBy('created','desc').get()
          .then(snapshots => {
              const tempCustomerList = []
              snapshots.forEach(snapshot => {
                    tempCustomerList.push(snapshot.data())
              })
              setCustomers(tempCustomerList)
          })
    })

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>顧客管理</h1>
            <div className='spacer-50' />
            <Wrapper>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>名前</TableCell>
                                <TableCell>メールアドレス</TableCell>
                                <TableCell>電話番号</TableCell>
                                <TableCell>購読状況</TableCell>
                                <TableCell>登録日時</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customers && customers.map(customer => (
                                <TableRow
                                style={{cursor:'pointer'}}
                                hover
                                key={customer.uid}
                                onClick={()=>dispatch(push('/admin/customer/dp/'+ customer.uid))}
                                >
                                    <TableCell>{`${customer.lastname} ${customer.firstname}`}</TableCell>
                                    <TableCell>{customer.email}</TableCell>
                                    <TableCell>{customer.tel}</TableCell>
                                    <TableCell>{customer.is_subscribe ? "購読中" : "未購読" }</TableCell>
                                    <TableCell>{customer.created ? dateTimeToString(customer.created.toDate()) : ""}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Wrapper>
            <div className='spacer-100' />
        </Layout>
    )
}
export default CustomerManager

const Wrapper = styled.div`
    width: 960px;
    margin: 0 auto;
`